import { Frame } from '@/lib/SFrame'

export const styles = {
    default: new Frame().shared({
        fontFamily: 'dms-medium',
        fontSize: '16px',
        color: 'var(--white)',
    }),
}
